/** @format */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import styled from 'src/ui/library/styled';
import 'src/styles/scss/components/servicespinnerSimple.scss';
const styles = theme => ({
  root: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
  },
  rootPaper: {
    'border-radius': '0px',
    'box-shadow': 'none',
    backgroundColor: 'rgba(0, 0, 0, 0)',
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
  },
  downloadServiceSpinner: {
    width: '300px',
    height: '300px',
    top: '186px',
    marginTop: '44px',
    marginLeft: '60px',
    zIndex: 1000,
  },
  loader: {
    border: '8px solid #b4b4b4',
    borderRadius: '50%',
    borderTop: '8px solid #2d3031',
    width: '120px',
    height: '120px',
    WebkitAnimation: 'spin 2s linear infinite',
    animation: 'spin 2s linear infinite',
  },
});

export function ServiceSpinner({ downlaodSpinner, faqSpinner, open, classes }) {
  return (
    <Dialog classes={{ root: classes.root, paper: classes.rootPaper }} open={open} maxWidth={'xl'}>
      {/* <svg className="download-service-spinner " width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <g transform="translate(1 1)" strokeWidth="2">
            <circle strokeOpacity=".15" cx="18" cy="18" r="18" />
            <path d="M36 18c0-9.94-8.06-18-18-18">
              <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
            </path>
          </g>
        </g>
      </svg> */}
      <div className={classes.downloadServiceSpinner}>
        <svg className={'ssi-spinner'} width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fillRule="evenodd">
            <g transform="translate(1 1)" strokeWidth="2">
              <circle strokeOpacity=".15" cx="18" cy="18" r="18" />
              <path d="M36 18c0-9.94-8.06-18-18-18">
                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
              </path>
            </g>
          </g>
        </svg>
      </div>
    </Dialog>
  );
}

export default styled(ServiceSpinner)(styles);
